import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortDropdown = _resolveComponent("SortDropdown")!
  const _component_SettingsBar = _resolveComponent("SettingsBar")!
  const _component_NLoadingCircle = _resolveComponent("NLoadingCircle")!
  const _component_NTable = _resolveComponent("NTable")!
  const _component_EntityBlank = _resolveComponent("EntityBlank")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!
  const _component_SettingsPageLayout = _resolveComponent("SettingsPageLayout")!

  return (_openBlock(), _createBlock(_component_SettingsPageLayout, null, {
    default: _withCtx(() => [
      (!_ctx.emptyItems)
        ? (_openBlock(), _createBlock(_component_SettingsBar, {
            key: 0,
            "create-label-i18-n": "external_vms.create_new",
            "total-count": _ctx.items.length,
            "has-create": _ctx.modelAcl.add,
            onSearch: _ctx.handleSearch,
            onCreate: _ctx.handleCreate
          }, {
            start: _withCtx(() => [
              _createVNode(_component_SortDropdown, {
                items: _ctx.sortTypes,
                modelValue: _ctx.module.filter.current.ordering,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.module.filter.current.ordering) = $event))
              }, null, 8, ["items", "modelValue"])
            ]),
            _: 1
          }, 8, ["total-count", "has-create", "onSearch", "onCreate"]))
        : _createCommentVNode("", true),
      (_ctx.module.items.length > 0 || _ctx.loading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_NLoadingCircle, {
                  key: 0,
                  class: "external-vms_loading"
                }))
              : (_openBlock(), _createBlock(_component_NTable, {
                  key: 1,
                  columns: _ctx.columns,
                  content: _ctx.computedVMSItems,
                  selected: _ctx.selectedEnrichedItems,
                  "onUpdate:selectedChanges": _ctx.handleSelect,
                  hoverable: "",
                  selections: ""
                }, null, 8, ["columns", "content", "selected", "onUpdate:selectedChanges"]))
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_EntityBlank, {
              "page-prefix": "ds",
              "page-type": _ctx.state.pageType,
              "is-empty": !_ctx.searchQuery.length,
              "has-create": _ctx.modelAcl.add,
              "create-icon": "add",
              onCreate: _ctx.handleCreate
            }, null, 8, ["page-type", "is-empty", "has-create", "onCreate"])
          ])),
      _createVNode(_component_InfiniteScroll, {
        filters: _ctx.module.filter.current,
        "next-page": _ctx.module.next_page,
        onLoadMore: _cache[1] || (_cache[1] = ($event: any) => (_ctx.append()))
      }, null, 8, ["filters", "next-page"])
    ]),
    _: 1
  }))
}